import { render } from "./BookingRequest.vue?vue&type=template&id=0dfeb954&scoped=true"
import script from "./BookingRequest.vue?vue&type=script&lang=js"
export * from "./BookingRequest.vue?vue&type=script&lang=js"

import "./BookingRequest.vue?vue&type=style&index=0&id=0dfeb954&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfeb954"]])

export default __exports__